import script from "./RegistaccountView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegistaccountView.vue?vue&type=script&lang=ts&setup=true"

import "./RegistaccountView.vue?vue&type=style&index=0&id=9555cbcc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9555cbcc"]])

export default __exports__